module.exports = __webpack_public_path__ + "static/media/riffrMockup.b9a51030.png";